import React, { Component } from 'react';
import { BaseResourceUrl } from '../common/ApiHelper';

interface ClassProps {
    data: Array<{
        id: string,
        src: string,
        name: string
    }>,
    onItemClick: (id: string) => void
}

class ClassComponent extends Component<ClassProps> {
    state = {
        showMoreClass: ''
    }
    public onMoreClick = () => {
        if (this.state.showMoreClass === 'on') 
            this.setState({showMoreClass: ''});
        else
            this.setState({showMoreClass: 'on'});
    }
    public render() {
        const { showMoreClass } = this.state;
        const { data, onItemClick } = this.props;
        let MoreOrNoMore = '收起';
        let layout = data.map(v=> 
            <li key={v.id} onClick={onItemClick.bind(this,v.id)}>
                <a>
                    <div className="c-img"><img src={ BaseResourceUrl + v.src } /></div>
                    <div className="c-tit">{v.name}</div>
                </a>
            </li>
        );
        if (showMoreClass === '') {
            layout = layout.slice(0, 9);
            MoreOrNoMore = '更多';
        }

        const more = <li onClick={this.onMoreClick} key='more' className="c-more">
            <a>
                <div className="c-img"><img src={require('../img/img19.jpg')}/></div>
                <div className="c-tit">{MoreOrNoMore}</div>
            </a>
        </li>;
        // layout.splice(9, 0, more);
        if (data.length > 10) {
            layout[layout.length] = more;
        }
        
        return (
            <div className="c-index2-menu">
                <ul className={showMoreClass}>
                    {layout}
                </ul>		    	
            </div>
        );
    }
}

export default ClassComponent;
